import {IFieldContainer, IFieldDefinition, IFormConfig, InputTypes, ValueTypes} from "../../../../../../interfaces";

const  widgetFormFields: IFormConfig = {
	fields: [
		// TODO ?
	]
};

export default widgetFormFields;